import ServiceIntro from './ServiceIntro';
import Donation from './Donation';
import { Wrapper } from '../Style';

function Service() {
  return (
    <Wrapper>
      <ServiceIntro />
      <Donation />
    </Wrapper>
  );
}

export default Service;
